import React from 'react';
import Ratings from '../common/Rating';
import Types from '../common/Types';
import UserAvatar from '../common/UserAvatar';


const tableConfig = (props) => (

    {
        columns: [
            {
                title: 'Seller Type', field: 'seller_type', filterAndSearch: false,
                render: rowData => <UserAvatar name={rowData.seller_type} image={rowData.business_dp_url} />
            },
            { title: 'Business Name', field: 'business_name', filterAndSearch: true },
            {
                title: 'Email', field: 'email_id', filterAndSearch: true,
                render: rowData => <div>{rowData.user && rowData.user.email_id ? rowData.user.email_id : "-"}</div>
            },
            {
                title: 'Mobile No', field: 'mobile_no', filterAndSearch: true,
                render: rowData => <div>{rowData.user && rowData.user.mobile_no ? rowData.user.mobile_no : "-"}</div>
            },
            {
                title: 'Cuisines', field: 'food_seller_cuisine_mappings', filterAndSearch: false,
                render: rowData => (
                    <ul>
                        {
                            rowData.food_seller_cuisine_mappings
                                ? rowData.food_seller_cuisine_mappings.map((cuisineData) => <li>{cuisineData.cuisine ? cuisineData.cuisine.cuisine_name : ''}</li>)
                                : "-"
                        }
                    </ul>
                ),
                width: "15%",
            },
            {
                title: 'Ratings', field: 'rating', filterAndSearch: false,
                render: rowData => <Ratings ratingCount={rowData.total_reviews} rating={rowData.rating} />
            },
            {
                title: 'Location', field: 'address_line1', filterAndSearch: true,
                render: rowData => <div>{rowData.address_line1 ? rowData.address_line1 : "-"}</div>
            },

            {
                title: 'Self-Pick up Discount Percentage', field: 'self_pickup_discount', filterAndSearch: false,
                render: rowData => <div>{rowData.self_pickup_discount ? rowData.self_pickup_discount : "-"}</div>
            },
            {
                title: 'Delivery Discount Percentage', field: 'delivery_discount', filterAndSearch: false,
                render: rowData => <div>{rowData.delivery_discount ? rowData.delivery_discount : "-"}</div>
            },
            {
                title: 'Minimum Cart Value', field: 'min_cart_amount', filterAndSearch: false,
                render: rowData => <div>{rowData.min_cart_amount ? rowData.min_cart_amount : "-"}</div>
            },
            {
                title: 'Max discount allowed', field: 'discount_cap_amount', filterAndSearch: false,
                render: rowData => <div>{rowData.discount_cap_amount ? rowData.discount_cap_amount : "-"}</div>
            },

            {
                title: 'Country Name', field: 'user.country.country_name', filterAndSearch: false,
                render: rowData => <div>{rowData.user && rowData.user.country && rowData.user.country.country_name ? rowData.user.country.country_name : "-"}</div>
            },
            {
                title: 'KYC', field: 'approval_status', filterAndSearch: false,
                render: rowData => <div className='text-capitalize'>{rowData.approval_status ? rowData.approval_status : "-"}</div>
            },
            {
                title: 'Activate Status', field: 'status', filterAndSearch: false,
                render: rowData => <div className='text-capitalize'>{rowData.status ? "Active" : "Inactive"}</div>
            }
        ],
    }
)


export const data = [
    {
        "userId": "rirani",
        "jobTitleName": "Developer",
        "firstName": "Romin",
        "lastName": "Irani",
        "preferredFullName": "Romin Irani",
        "employeeCode": "E1",
        "region": "CA",
        "phoneNumber": "408-1234567",
        "emailAddress": "romin.k.irani@gmail.com",
        "rating": '4.5',
        "ratingCount": '120'
    },
    {
        "userId": "nirani",
        "jobTitleName": "Developer",
        "firstName": "Neil",
        "lastName": "Irani",
        "preferredFullName": "Neil Irani",
        "employeeCode": "E2",
        "region": "CA",
        "phoneNumber": "408-1111111",
        "emailAddress": "neilrirani@gmail.com",
        "rating": '4.2',
        "ratingCount": '130'
    },
    {
        "userId": "thanks",
        "jobTitleName": "Program Directory",
        "firstName": "Tom",
        "lastName": "Hanks",
        "preferredFullName": "Tom Hanks",
        "employeeCode": "E3",
        "region": "CA",
        "phoneNumber": "408-2222222",
        "emailAddress": "tomhanks@gmail.com",
        "rating": '4.1',
        "ratingCount": '140'
    },
    {
        "userId": "thankss",
        "jobTitleName": "Program Directorys",
        "firstName": "Toms",
        "lastName": "Hankss",
        "preferredFullName": "Tom Hanksss",
        "employeeCode": "E3s",
        "region": "CAs",
        "phoneNumber": "408-22222222",
        "emailAddress": "tomhanks@gmail.coms",
        "rating": '4.5',
        "ratingCount": '150'
    }
];

export default tableConfig;